import { render, staticRenderFns } from "./ViewCheckoffs.vue?vue&type=template&id=2c3b4ada&"
import script from "./ViewCheckoffs.vue?vue&type=script&lang=js&"
export * from "./ViewCheckoffs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports